















import Vue, { PropOptions } from 'vue';

export type LogosItemClickable = Blok & {
  image: BlokFieldAsset;
  badge?: string;
  link: BlokFieldLink;
  width?: string;
  height?: string;
};

export default Vue.extend({
  props: {
    blok: {
      type: Object,
      required: true,
    } as PropOptions<LogosItemClickable>,
  },
  computed: {
    linkComponent(): string {
      return this.isExternalLink ? 'a' : 'nuxt-link';
    },
    isExternalLink(): boolean {
      return this.blok.link.linktype === 'url';
    },
    to(): string {
      return !this.isExternalLink ? this.blok?.link?.cached_url : '';
    },
    href(): string {
      return this.isExternalLink ? this.blok?.link?.url : '';
    },
    target(): string {
      return this.isExternalLink ? '_blank' : '';
    },
    cssVars(): CSSVars {
      return {
        '--logos-item-clickable-width': this.blok.width || 'unset',
        '--logos-item-clickable-height': this.blok.height || 'unset',
      };
    },
  },
});
